/** Same footprint across normal/lightweight canvas and unmeasured layout fallbacks. */
export const SHOT_LIST_NODE_DIMS = { width: 1180, height: 560 }

export function isShotListLayout(node: { type?: string | null; data?: object }): boolean {
  return node.type === 'storyboardDesigner' &&
    node.data !== undefined &&
    'storyboard_view' in node.data &&
    node.data.storyboard_view === 'shot_list'
}
